import { lazy } from 'react';

import NavigationDefault from 'app/components/Navigation/NavigationDefault';
import TableComponent from 'app/components/Table/TableComponent';
import { QUERIES } from 'app/components/Table/core/constants';
import { TYPE_MODAL } from 'app/components/Table/core/types';

import {
  NAVIGATION_ITEM_LOCATION,
  TAB_ITEM,
} from 'app/modules/system-settings/configuration/core/constants';
import {
  itemQueryToTabMap,
  tabItemToQueryMap,
} from 'app/modules/system-settings/configuration/core/utils';

import { useTab } from 'app/hooks/useTab';

import { quantityUnitsColumns } from './core/columns';
import { deleteSetting, getSettings } from './core/request';
import { Setting, SettingType } from './core/type';
import { FormQuantityUnitTableCard } from './modal/FormQuantityUnitTableCard';
import UnableDeleteUnit from './modal/UnableDeleteUnit';
import { SuspensedView } from 'app/routing/PrivateRoutes';

const ItemExpiry = lazy(() => import('./ItemExpiry'));

export const ConfigQuantityUnitPage = () => {
  const renderModalForm = (originalData: Setting, _typeModal: TYPE_MODAL, isView?: boolean) => {
    return <FormQuantityUnitTableCard setting={originalData} originIsView={isView} />;
  };

  const renderModalOutsideTable = (_originalData: Setting, typeModal?: TYPE_MODAL) => {
    if (typeModal === TYPE_MODAL.UNABLE_DELETE_UNIT) {
      return <UnableDeleteUnit />;
    }

    return <div />;
  };

  const { tab, handleChangeNavigation } = useTab(
    itemQueryToTabMap,
    tabItemToQueryMap,
    NAVIGATION_ITEM_LOCATION,
  );

  return (
    <>
      <NavigationDefault
        navigation={NAVIGATION_ITEM_LOCATION}
        valueActive={tab}
        onChangeNavigation={handleChangeNavigation}
      />
      {tab == TAB_ITEM.QUANTITY_UNIT ? (
        <TableComponent
          getList={getSettings}
          nameQuery={QUERIES.SETTING_LIST}
          originColumns={quantityUnitsColumns()}
          ModalForm={renderModalForm}
          titleModal="Unit"
          placeholderSearch="Search with unit"
          nameBtnAdd="Add unit"
          ModalOutsideTable={renderModalOutsideTable}
          deleteById={deleteSetting}
          moreQuery={`&type=${SettingType.quantityUnit}`}
          isBorder={false}
          fieldCheckShowCursorInRow="meta"
          spacing="xxl"
        />
      ) : (
        <SuspensedView>
          <ItemExpiry />
        </SuspensedView>
      )}
    </>
  );
};
